export function addCurrent(originrequest) {
    return {
        type: 'ADD_CURRENT',
        originrequest,
    }
}
